import { useContext } from 'react';
import { retryContext } from '../../context';
export var useCreditCardRetry = function useCreditCardRetry() {
  return useContext(retryContext);
};